/**
 * CJdropshipping Alternatives 主页面 — 服务端数据获取
 * 纯展示页面，无需调用后端 API，仅返回 SEO 信息和 CDN 配置。
 *
 * 【注意】cdnHost 获取链路：
 * - SSR 模式：通过 eggCtx.app.config.view.variable.CDN_HOST 获取
 * - CSR fallback：从 layout 模板注入的全局变量 CDN_HOST 获取
 * 与 odm/fetch.js 逻辑完全一致。
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @returns {Object} 包含 __seo 和 cdnHost 字段
 */
async function fetchData(ctx) {
  let cdnHost = '';
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  return {
    cdnHost,
    __seo: {
      title: 'CJdropshipping Alternatives - How CJdropshipping Alternatives Compare',
      keywords:
        'CJdropshipping alternatives, best CJdropshipping alternatives, CJdropshipping competitors',
      description:
        'Discover the best CJdropshipping alternatives. Compare pricing, shipping, sourcing, automation, and fulfillment services for your dropshipping business.',
    },
  };
}

module.exports = fetchData;
